import { render, staticRenderFns } from "./TicketsRevenue.vue?vue&type=template&id=dc23f22a&scoped=true&"
import script from "./TicketsRevenue.vue?vue&type=script&lang=ts&"
export * from "./TicketsRevenue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc23f22a",
  null
  
)

export default component.exports